import { defineStyle as o, defineStyleConfig as e } from "@chakra-ui/react";
const a = o({
  color: "gray.700",
  background: "transparent",
  borderColor: "transparent",
  _disabled: {
    color: "gray.800",
    opacity: 0.5,
    cursor: "not-allowed",
    boxShadow: "none",
    _hover: { bg: "none" }
  },
  _hover: { bg: "blackAlpha.100" },
  _active: { bg: "blackAlpha.200" },
  _focusVisible: {
    boxShadow: "outline"
  }
}), t = e({
  baseStyle: a
});
export {
  t as default
};
